import React, { Component } from 'react'

export default function FormLoader({ icon = 'spinner' }) {
  return (
    <div className="form-loader">
      <i className={`fa fa-spin fa-${icon}`} />
    </div>
  )
}
